// components/ShopCardComponent.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import api from "../api"; // centralized axios instance
import "../css/ShopCardComponent.css";

const ShopCardComponent = ({ shop, onDelete, handleViewProducts }) => {
  const navigate = useNavigate();

  // ✅ Navigate to shop details
  const handleCardClick = () => {
    navigate(`/shop-details/${shop.id}`);
  };

  // ✅ Build full image URL
  const getShopLogo = () => {
    if (!shop.logo) return "/images/default-shop.png";
    return shop.logo.startsWith("http")
      ? shop.logo
      : `${api.defaults.baseURL.replace("/auth", "")}${shop.logo}`;
  };

  // ✅ Handle Delete API
  const handleDelete = async (e) => {
    e.stopPropagation(); // Prevent navigation
    try {
      const response = await api.delete(`/shops/delete/${shop.id}/`);
      console.log("🗑️ Shop deleted:", response.data);

      // Notify parent (to refresh list)
      if (onDelete) onDelete(shop.id);
    } catch (error) {
      console.error("❌ Error deleting shop:", error);
      alert("Failed to delete shop. Please try again.");
    }
  };

  return (
    <div className="shop-card">
      {/* Clicking the card navigates to Shop Details */}
      <div className="shop-card-background" onClick={handleCardClick}>
        <div
          className="shop-card-image"
          style={{
            backgroundImage: `url(${getShopLogo()})`,
          }}
        ></div>
      </div>

      <div className="shop-card-bottom">
        <h3 className="shop-card-title">
          {shop.shop_name}
          {shop.address ? `, ${shop.address}` : ""}
        </h3>

        <div className="shop-card-buttons">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleViewProducts(shop);
            }}
            className="shop-card-view-btn"
          >
            View Products
          </button>

          <button
            onClick={handleDelete}
            className="shop-card-delete-btn"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShopCardComponent;
